var BASE_URL = location.protocol + "//cmsauth.baowugroup.com";
var API_URL = location.protocol + "//cmsauth.baowugroup.com";
const dict = {
  //全局字典
  SETTING: {
    BASE_URL: BASE_URL, //web站点路径
    API_URL: API_URL, //API具体路径
    TAG_LIST: false, //是否启用tag
    DOWN_TEMP_PATH: BASE_URL + "/file/upload/totalExcelImport/", //导出、离职、调岗生成的文件下载路径
    TEMP_PATH: BASE_URL + "/file/upload/img/temp/", //临时文件路径
    FORMAL_PATH: BASE_URL + "/file/upload/img/permanentFile/", //正式文件地址
  },
  DIALOG_WIDTH: ["420px", "1100px", "780px"], //弹出层大小
  CENSUS_TYPE: [
    {
      value: "1",
      label: "本地农业",
    },
    {
      value: "2",
      label: "本地非农业",
    },
    {
      value: "3",
      label: "外地农业",
    },
    {
      value: "4",
      label: "外地非农业",
    },
  ]
};
/**
 * 生产环境 使用 public目录下 setting.js声明的全局变量
 */
if (process.env.NODE_ENV === "production") {
  dict.SETTING = Object.assign(dict.SETTING, window.ADMIN_SETTING);
}

dict.getValue = getValue; //最后加入到dict中，防止for...in遍历到
dict.getData = getData;

function getValue(dict, value, key) {
  if (value == null || value == undefined) {
    return "";
  }
  if (typeof value == "object") {
    value = value[key];
  }
  var item =
    dict.find((item) => {
      return item.value == value;
    }) || {};
  return item.label || "--";
}
function getData(dict, key, value) {
  if (value == null || value == undefined) {
    return "";
  }
  if (typeof value == "object") {
    value = value[key];
  }
  var item =
    dict.find((item) => {
      return item.value == value;
    }) || {};
  return item || {};
}
export default dict;
